jQuery(document).ready(function() {
  
     $('.bloodcollection_slider').slick({
        dots: true,
        infinite: true,
        autoplay: true, 
        autoplaySpeed: 10000,
        slidesToShow: 1,
        adaptiveHeight: true
    });

    $('.team_nav').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow:4,
        arrows : true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
          },
          {
            breakpoint:600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
    });

    $('.popup-modal').magnificPopup({
        type: 'inline',
        preloader: false,
        focus: '#name',
        closeBtnInside: false,
        closeOnContentClick: false,
        closeOnBgClick: true,
        enableEscapeKey: true,
        modal: true,
        asNavFor: ".mfp-arrow",
        gallery: {
            enabled: true,
            tPrev: '@T("Media.MagnificPopup.Previous")',
            tNext: '@T("Media.MagnificPopup.Next")',
        }
    });

    $('.scientific-popup-modal').magnificPopup({
        type: 'inline',
        preloader: false,
        focus: '#username',
        modal: true
    });
        
    $(document).on('click', '.popup-modal-dismiss', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });

});